import React, { useRef, useState } from 'react';

// import { CheckRadio } from 'screens/home/tasksList/styles';
import {
  Box,
  CircularProgress,
  Menu,
  MenuItem, //  Tooltip, Zoom
} from '@material-ui/core';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
// import VisibilityComponent from 'components/feed/PostVisibilityComponent';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { DeleteKRModalGoalsRevamp } from 'components/ObjectiveTagList/ModalPromptView';
import useReactions from 'components/feed/useReactions';
import { useMatchedRoute } from 'components/hooks/useMatchedRoute';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { openKRPromptModal } from 'reducers/keyResultPromptModal';
import { selectMSTeamsContext } from 'selectors/msTeamsSelector';
import styled from 'styled-components';
import {
  NewStyledIconButton,
  StyledBox,
  // StyledTypography,
  VerticallyAlignedFlexContainer,
} from 'styles/common';

// import { Skeleton } from '@material-ui/lab';
import { REACTIONS, TASK_TYPES_2 } from 'constants/ProjectConstants';
import { getTaskDetailsRoute } from 'constants/helper';
import {
  DeleteIconFilled,
  DotsIcon,
  LinkIcon,
  StyledIcon,
  StyledIconV2, // UncheckedCircle
} from 'constants/icons';
import { isMobileView } from 'constants/isMobileView';
import {
  GOAL_EVENTS1,
  ONE_ON_ONE_EVENTS_OLD,
  sendGoalEvent,
  sendOneOnOneEvent,
  sendShareKREvent,
  sendTaskEvent,
  TASK_EVENTS,
} from 'constants/mixpanelHelper';
import { isNetchexLogin } from 'constants/netChexConstants';
import theme from 'constants/theme';

import { FEED_TYPES } from 'services/helpers/feed';
import { showSuccessSnackbar, showErrorSnackbar } from 'services/snackbar';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Typography4 } from 'uiToolkit/Typography';

const BackIconComponent = ({ showTrackingDetails, toggleShowTrackingDetails, onClickHandler = null }) => {
  const history = useHistory();
  const onClick = () => {
    if (showTrackingDetails) {
      toggleShowTrackingDetails(false);
    } else {
      history.goBack();
    }
  };
  return (
    <NewStyledIconButton padding="small" onClick={onClickHandler || onClick} rightGutter={1}>
      <StyledIcon size="header" color="textSecondary">
        <ArrowBackRoundedIcon />
      </StyledIcon>
    </NewStyledIconButton>
  );
};

const GenericBackIconComponent = ({ onClickHandler }) => (
  <NewStyledIconButton padding="small" onClick={onClickHandler} rightGutter={1}>
    <StyledIcon size="header" color="textSecondary">
      <ArrowBackRoundedIcon />
    </StyledIcon>
  </NewStyledIconButton>
);

export const CheckInSidePanelHeader = ({ closePanel, backButtonHandler = null, children }) => (
  <HeaderContainer style={{ marginLeft: '0.875rem', justifyContent: 'flex-start' }}>
    <VerticallyAlignedFlexContainer>
      <NewStyledIconButton onClick={closePanel} padding="large">
        <StyledIcon color="textSecondary" size="header">
          <CloseRoundedIcon />
        </StyledIcon>
      </NewStyledIconButton>
    </VerticallyAlignedFlexContainer>
    {children}
  </HeaderContainer>
);

export const GenericSidePanelHeader = ({ closePanel, backButtonHandler = null, leftChild, className }) => (
  <HeaderContainer className={className}>
    {/* just to keep right alignment of close button when back button is not there */}
    {backButtonHandler && (
      <VerticallyAlignedFlexContainer>
        <GenericBackIconComponent onClickHandler={backButtonHandler} />
      </VerticallyAlignedFlexContainer>
    )}
    {leftChild && <Box marginRight="auto">{leftChild}</Box>}
    {closePanel && (
      <NewStyledIconButton onClick={closePanel} padding="large" style={{ marginLeft: 'auto' }}>
        <StyledIcon color="textSecondary" size="header">
          <CloseRoundedIcon />
        </StyledIcon>
      </NewStyledIconButton>
    )}
  </HeaderContainer>
);

const DropdownOptions = ({
  isUpdating = false,
  taskId,
  taskDetails,
  taskType = 'GOAL',
  canShowDeleteIcon = false,
  onDeleteClick,
  onLikeClick,
  onApplaudClick,
  currentReactions,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isGoal = taskType === 'GOAL';

  const route = getTaskDetailsRoute({
    location,
    ids: [taskId],
    useCurrentRoute: isNetchexLogin ? true : false,
    type: taskType,
  });

  const url = window.location.origin + route;

  const textAreaRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);

  const isMsTeamsVisitor = useSelector(selectMSTeamsContext);

  function textToClipboard(text) {
    textAreaRef.current.select();
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand#browser_compatibility
    // document.execCommand('copy');
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(showSuccessSnackbar('Successfully copied url to clipboard'));
      })
      .catch(() => {
        dispatch(showErrorSnackbar('Error while copying url to clipboard'));
      });
  }

  const handleMoreOptionsMenuOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleMoreOptionsMenuClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleOptionSelect = (e, option) => {
    switch (option) {
      case 'SHARE': {
        if (taskType === 'GOAL') {
          sendShareKREvent({
            eventProperties: {
              goalId: taskId,
            },
          });
        }
        textToClipboard(url);
        break;
      }
      case 'DELETE': {
        onDeleteClick();
        break;
      }
      case 'LIKE': {
        onLikeClick();
        break;
      }
      case 'APPLAUD': {
        onApplaudClick();
        break;
      }
      default:
        break;
    }
    handleMoreOptionsMenuClose(e);
  };

  return (
    <>
      {isUpdating ? (
        <CircularProgress size={24} style={{ marginLeft: '8px', display: 'inline-flex' }} />
      ) : (
        <StyledBox>
          <CircularOutlineIcon
            leftGutter={1}
            onClick={handleMoreOptionsMenuOpen}
            color="primary"
            icon={StyledDotsIcon}
          />
          <StyledMenu
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            getContentAnchorEl={null}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMoreOptionsMenuClose}
          >
            {!isMobileView() && !isMsTeamsVisitor && (
              <StyledMenuItem onClick={(e) => handleOptionSelect(e, 'SHARE')}>
                <CopyFromTextArea
                  ref={textAreaRef}
                  value={url}
                  style={{ position: 'absolute', zIndex: '-1', height: 0, opacity: '0.01' }}
                />
                <StyledIconV2 size="fixed12px" color={theme.palette.icons.blackv1}>
                  <LinkIcon />
                </StyledIconV2>
                <Typography4 leftGutter={2} color={theme.palette.text.heading}>
                  Share
                </Typography4>
              </StyledMenuItem>
            )}

            {canShowDeleteIcon ? (
              <StyledMenuItem onClick={(e) => handleOptionSelect(e, 'DELETE')}>
                <StyledIconV2 size="fixed12px" color={theme.palette.icons.blackv1}>
                  <DeleteIconFilled />
                </StyledIconV2>
                <Typography4 leftGutter={2} color={theme.palette.text.heading}>
                  Delete
                </Typography4>
              </StyledMenuItem>
            ) : null}
          </StyledMenu>
        </StyledBox>
      )}
    </>
  );
};

const StyledDotsIcon = styled(DotsIcon)`
  width: 13px;
  margin-top: 1px;
`;

const StyledMenu = styled(Menu)`
  ul {
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .MuiPopover-paper {
    box-shadow: 3px 4px 5px 0px #0000001c;
    border: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 0px 24px;
  display: flex;
  align-items: center;
  min-height: 32px;
`;

export default function TasksGoalsSidepanelHeader({
  closePanel,
  isUpdating,
  loading,
  taskDetails,
  updateTask,
  showRecurrentTasks,
  showTrackingDetails,
  // onDelete,
  onDeleteClick,
  toggleShowTrackingDetails,
  showOnlyCloseOptions = false,
}) {
  const { pageName } = useMatchedRoute();

  const dispatch = useDispatch();

  const canShowDeleteIcon =
    onDeleteClick &&
    !loading &&
    !showRecurrentTasks &&
    taskDetails.type !== TASK_TYPES_2.checkIn &&
    (taskDetails.type === TASK_TYPES_2.goal ? taskDetails?.actions?.delete?.canPerform : true);
  const isGoal = taskDetails && taskDetails.type === TASK_TYPES_2.goal;
  const taskReactions = taskDetails ? taskDetails.reactions || {} : {};
  const taskId = taskDetails ? taskDetails.id : {};
  const {
    reactions: currentReactions,
    onAddReaction,
    onRemoveReaction,
  } = useReactions(taskReactions, taskId, FEED_TYPES.task);

  const sendTrackingEvent = () => {
    if (taskDetails.taskType === TASK_TYPES_2.checkIn) {
      sendOneOnOneEvent({
        eventName: ONE_ON_ONE_EVENTS_OLD.applaused,
        page: {
          pageName,
          flow: 'Activity',
        },
      });
    } else if (taskDetails.type === TASK_TYPES_2.goal) {
      sendGoalEvent({
        eventName: GOAL_EVENTS1.applaused,
        page: {
          pageName,
          flow: 'Activity',
        },
      });
    } else if (taskDetails.type === TASK_TYPES_2.task) {
      sendTaskEvent({
        eventName: TASK_EVENTS.applaused,
        page: {
          pageName,
          flow: 'Activity',
        },
      });
    }
  };

  const handleDeleteClick = () => {
    if (taskDetails.type === TASK_TYPES_2.goal) {
      sendGoalEvent({
        eventName: GOAL_EVENTS1.goalDeleted,
        page: {
          pageName,
          flow: 'Activity',
        },
      });

      // onDeleteClick();
      dispatch(
        openKRPromptModal(
          <DeleteKRModalGoalsRevamp
            onDelete={onDeleteClick}
            // objectiveTimeBoundId={objectiveDetails.objectiveTimeBoundId}
            // tag={objectiveDetails}
          />
        )
      );
    } else {
      // FOR INITIATIVE
      onDeleteClick();
    }
  };

  const onLikeClick = () => {
    if (currentReactions.isLiked) {
      onRemoveReaction({ reactionType: REACTIONS.like });
    } else {
      onAddReaction({ reactionType: REACTIONS.like });
    }
    sendTrackingEvent();
  };

  const onApplaudClick = () => {
    if (currentReactions.isApplauded) {
      onRemoveReaction({ reactionType: REACTIONS.applause });
    } else {
      onAddReaction({ reactionType: REACTIONS.applause });
    }
    sendTrackingEvent();
  };

  return (
    <HeaderContainer>
      {!isGoal && (
        <BackIconComponent
          showTrackingDetails={showTrackingDetails}
          toggleShowTrackingDetails={toggleShowTrackingDetails}
        />
      )}
      {isGoal && (
        <BackIconComponent
          showTrackingDetails={showTrackingDetails}
          toggleShowTrackingDetails={toggleShowTrackingDetails}
        />
      )}
      <StyledBox style={{ marginLeft: 'auto' }} display="flex" alignItems="center">
        {!showOnlyCloseOptions && (
          <DropdownOptions
            isUpdating={isUpdating}
            taskId={taskDetails.id}
            taskType={taskDetails.type}
            canShowDeleteIcon={canShowDeleteIcon}
            onDeleteClick={handleDeleteClick}
            taskDetails={taskDetails}
            currentReactions={currentReactions}
            onLikeClick={onLikeClick}
            onApplaudClick={onApplaudClick}
          />
        )}
        <NewStyledIconButton leftGutter={2} onClick={closePanel} disabled={isUpdating} padding="large">
          <StyledIcon color="textSecondary" size="header">
            <CloseRoundedIcon />
          </StyledIcon>
        </NewStyledIconButton>
      </StyledBox>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0;
  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 28px 24px 0 24px;
  }
`;

// const HeaderActions = styled.div``;

const CopyFromTextArea = styled.textarea`
  width: 0;
  position: absolute;
  z-index: -1;
  height: 0;
  opacity: 0.01;
`;
